import CircularProgress from "@mui/material/CircularProgress";
import React from "react";

export default ({className, color, size}) => <CircularProgress className={className} color={color} disableShrink={true} size={(size || 30)} />;
